import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "./routes/login";
import { Shell } from "./components/layout/shell";
import { Dashboard } from "./routes/dashboard";
import { CallsList } from "./routes/calls/list";
import { CallDetail } from "./routes/calls/detail";
import { CallsLive } from "./routes/calls/live";
import { BookingsList } from "./routes/bookings/list";
import { TenantsList } from "./routes/tenants/list";
import { TenantSettings } from "./routes/tenants/settings";
import { CallbacksList } from "./routes/callbacks/list";
import { KbList } from "./routes/kb/list";
import { ForwardsList } from "./routes/forwards/list";
import { NumbersList } from "./routes/numbers/list";
import { VoiceSimulator } from "./routes/dev/voice-simulator";
import { CrmPipeline } from "./routes/crm/pipeline";
import { CrmAgenda } from "./routes/crm/agenda";
import { CrmRevenues } from "./routes/crm/revenues";
import { CrmAccount } from "./routes/crm/account";
import { SupervisionPage } from "./routes/supervision/index";
import { SupervisionCallPage } from "./routes/supervision/call";
import { SupervisionSourcesPage } from "./routes/supervision/sources";
import { LeoRoute } from "./routes/leo/index";
import { useAuthStore } from "./stores/auth";

export default function App() {
  const { user, loading, refresh } = useAuthStore();

  useEffect(() => {
    refresh();
  }, [refresh]);

  if (loading) {
    return <div className="boot">Chargement…</div>;
  }

  if (!user) return <Login />;

  // Pages réservées aux admins : un utilisateur « établissement » qui tape
  // l'URL à la main est renvoyé au tableau de bord (l'API 403 de toute façon,
  // mais on évite les pages cassées).
  const admin = (el: JSX.Element) => (user.role === "admin" ? el : <Navigate to="/dashboard" replace />);

  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/leo" element={<LeoRoute />} />
        <Route path="/calls" element={<CallsList />} />
        <Route path="/calls/live" element={<CallsLive />} />
        <Route path="/calls/:callId" element={<CallDetail />} />
        <Route path="/bookings" element={<BookingsList />} />
        <Route path="/callbacks" element={<CallbacksList />} />
        <Route path="/kb" element={<KbList />} />
        <Route path="/forwards" element={<ForwardsList />} />
        <Route path="/tenants" element={admin(<TenantsList />)} />
        <Route path="/numbers" element={admin(<NumbersList />)} />
        <Route path="/tenants/:tenantId/settings" element={<TenantSettings />} />
        <Route path="/dev/voice-simulator" element={admin(<VoiceSimulator />)} />
        <Route path="/crm" element={admin(<CrmPipeline />)} />
        <Route path="/crm/agenda" element={admin(<CrmAgenda />)} />
        <Route path="/crm/revenus" element={admin(<CrmRevenues />)} />
        <Route path="/crm/dossiers/:accountId" element={admin(<CrmAccount />)} />
        <Route path="/supervision" element={admin(<SupervisionPage />)} />
        <Route path="/supervision/sources" element={admin(<SupervisionSourcesPage />)} />
        <Route path="/supervision/:sourceId/appels/:callId" element={admin(<SupervisionCallPage />)} />
      </Routes>
    </Shell>
  );
}
